<template>
  <div>
    <div class="products-grid">
      <AppProductCard
        v-for="p in products"
        :key="p.id"
        :id="p.id"
        :slug="p.slug"
        :img="p.get_image"
        :name="p.name"
        :price="getPriceForCurrency(p)"
        :currency="getCurrencySymbol(currentCurrency.value)"
      />
    </div>
    <div v-if="loading">Ładowanie...</div>
    <div v-if="error">{{ errorMsg }}</div>
  </div>
</template>

<script>
import AppProductCard from './AppProductCard.vue'
import { currentLang } from '@/locales/lang'
import { currentCurrency } from '@/composables/currency'

export default {
  name: "AppProductList",
  components: { AppProductCard },
  data() {
    return {
      products: [],
      loading: false,
      error: false,
      errorMsg: ""
    }
  },
  mounted() {
    this.loadProducts();
    window.addEventListener('languageChanged', this.loadProducts);
    window.addEventListener('currencyChanged', this.loadProducts);
  },
  beforeUnmount() {
    window.removeEventListener('languageChanged', this.loadProducts);
    window.removeEventListener('currencyChanged', this.loadProducts);
  },
  methods: {
    async loadProducts() {
      this.loading = true;
      try {
        const res = await fetch('https://birdstool.pl/api/v1/latest-products/', {
          headers: {
            'Accept-Language': currentLang.value,
            // 'X-Currency': currentCurrency.value // API zwraca wszystkie waluty, więc nie potrzebne
          }
        });
        const data = await res.json();
        if (!res.ok) throw new Error("HTTP error " + res.status + " " + (data && JSON.stringify(data)));
        this.products = data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.error = true;
        this.errorMsg = error.message;
        alert('Błąd: ' + error);
      }
    },
    getPriceForCurrency(product) {
    const priceKey = {
      PLN: 'price_pln',
      EUR: 'price_eur',
      USD: 'price_usd',
      CZK: 'price_czk',
      HUF: 'price_huf',
      BGN: 'price_bgn',
      RON: 'price_ron',
      DKK: 'price_dkk',
      SEK: 'price_sek'
    }[currentCurrency.value] || 'price_pln';


  const priceRaw = product[priceKey];

  // Spróbuj przekonwertować na number
  const priceNum = Number(priceRaw);

  // Jeśli nie jest liczbą (NaN), zwróć '0.00'
  if (isNaN(priceNum)) return '0.00';

  // W przeciwnym razie zwróć zaokrągloną cenę jako string
  return priceNum.toFixed(2);
},
    getCurrencySymbol(currencyCode) {
      const symbols = {
        PLN: 'zł',
        USD: '$',
        EUR: '€',
        CZK: 'Kč',   // korona czeska
        HUF: 'Ft',   // forint
        BGN: 'лв',   // lew bułgarski
        RON: 'lei',  // lej rumuński
        DKK: 'kr.',  // korona duńska
        SEK: 'kr'    // korona szwedzka
      };
      return symbols[currencyCode] || currencyCode;
    }
  },
  computed: {
    currentCurrency() {
      return currentCurrency;
    }
  }
}
</script>
